import type { Configuration, RedirectRequest, SilentRequest } from "@azure/msal-browser";

const redirectUri = import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin;
const ORG_AUTHORITY = "https://login.microsoftonline.com/organizations";

export const ARM_TENANTS_URL = "https://management.azure.com/tenants?api-version=2020-01-01";

export const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
        authority: ORG_AUTHORITY,
        redirectUri,
        postLogoutRedirectUri: redirectUri,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest: RedirectRequest = {
    scopes: ["openid", "profile", "offline_access"],
    // Pre-consent ARM so TenantContext can silently acquire an ARM token
    // without triggering a second interactive prompt.
    extraScopesToConsent: ["https://management.azure.com/.default"],
    authority: ORG_AUTHORITY,
    extraQueryParameters: { instance_aware: "true" },
};

export const armTokenRequest = {
    scopes: ["https://management.azure.com/.default"],
    authority: ORG_AUTHORITY,
    extraQueryParameters: { instance_aware: "true" } as Record<string, string>,
};

export function buildApiTokenRequest(tenantId: string): SilentRequest {
    return {
        scopes: [import.meta.env.VITE_API_SCOPE],
        authority: `https://login.microsoftonline.com/${tenantId}`,
    };
}
